import React from "react";

const UpdateConfirmModal = ({
  isOpen,
  folderName,
  selectedLanguage,
  onCancel,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal"
      id="MoveFolder"
      style={{ display: "block", backgroundColor: "#8080801c" }}>
      <div className="modal-dialog modal-dialog-centered modal-customelg">
        <div className="modal-content">
          <div className="modal-header pb-1">
            <h4
              className="d-flex align-items-center text-danger fw-bold "
              htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_Update}
            </h4>
          </div>
          <div
            className="d-flex justify-content-center flex-column mb-3 text-center"
            style={{ marginTop: "20px" }}>
            <p className="w-100 f-w550" style={{ fontSize: "18px" }}>
              {" "}
              {selectedLanguage.LstLanguageCodes.UI_UpdateConfirmMsg}{" "}
              {folderName}?
            </p>
          </div>
          <div className="d-flex justify-content-center mb-4 ">
            <button
              type="button"
              className="btn btn-danger px-4 me-1"
              data-bs-dismiss="modal"
              onClick={(e) => onCancel()}>
              {selectedLanguage.LstLanguageCodes.UI_Cancel}
            </button>
            <button
              type="button"
              className="btn btn-primary px-4 ms-3"
              onClick={(e) => onConfirm()}>
              {selectedLanguage.LstLanguageCodes.UI_Confirm}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateConfirmModal;
